import { NgModule } from '@angular/core';
import { ActionsService } from './actions/actions.service';
import { AssignmentsService } from './assignments/assignments.service';
import { OperationsService } from './operations/operations.service';
import { SegmentationsService } from './segmentations/segmentations.service';
import { UsersService } from './users/users.service';

@NgModule({
  providers: [
    ActionsService,
    AssignmentsService,
    OperationsService,
    SegmentationsService,
    UsersService
  ]
})
export class SharedFirebaseServicesModule {}
